import { Single } from 'infrastructure/api'

import { useCallback } from 'react'
import { format, parse } from 'date-fns'
import { FEATURE_PACKAGES } from 'shared/api/platformFeatures/platformFeatures.utils'

export const LockedSchoolsIds = [1102828]

export const scrollToBottom = () => {
  window.scroll({
    top: document.body.offsetHeight,
    left: 0,
    behavior: 'smooth',
  })
}

export const roleNameMap: { [key: string]: string } = {
  'INTERNAL admin': 'admin',
  'INTERNAL super': 'super-admin',
  'district-admin': 'district-admin',
  'school-admin': 'administrator',
  publisher: 'publisher',
  student: 'student',
  teacher: 'teacher',
  'school editor': 'editor',
  'demo teacher': 'demo-teacher',
  'district-editor': 'district-editor',
  'INTERNAL Data Wiping Admin': 'data-wiping-admin',
  'INTERNAL View Only Admin': 'view-only-admin',
  'INTERNAL impersonator': 'impersonator',
}

export const basicRoleNameMap: { [key: string]: string } = {
  student: 'student',
  teacher: 'teacher',
}

export const reverseMap = (map: { [key: string]: string }) => {
  const revRoleNameMap: { [key: string]: string } = {}
  for (const [key, value] of Object.entries(map)) {
    revRoleNameMap[value] = key
  }
  return revRoleNameMap
}

export const packageListStringFromFeatures = (
  platformFeatures: Single.PlatformFeature[],
) => {
  return transformFeaturesIntoPackages(platformFeatures)
    .filter(([_packageName, packageFeatures]) => {
      return packageFeatures.length > 0
    })
    .map(([packageName]) => packageName)
    .join(', ')
}

const EXCLUDED_FEATURES = [
  'skill-correlation',
  'question-type-drawing',
  'question-type-classifying',
  'question-type-placeholder',
  'question-type-matching',
  'question-type-ordering',
  'question-type-short-answer',
]

export function transformFeaturesIntoPackages(
  platformFeatures: Single.PlatformFeature[],
) {
  const scrubbedFeatures = platformFeatures.filter(
    (individualFeature) => !EXCLUDED_FEATURES.includes(individualFeature.name),
  )
  const matchedFeaturePackages = Object.entries(FEATURE_PACKAGES).map(
    ([packageName, packageFeatures]) => {
      return [
        packageName,
        packageFeatures.reduce(
          (acc: Single.PlatformFeature[], name: string) => {
            const matched = scrubbedFeatures.find(
              (f: Single.PlatformFeature) => f.name === name,
            )
            return matched ? [...acc, matched] : [...acc]
          },
          [],
        ),
      ]
    },
  )
  return matchedFeaturePackages
}

export function useNoPropagateHandler<T extends { stopPropagation(): void }>(
  handler?: (e: T) => void,
) {
  return useCallback(
    (e: T) => {
      e.stopPropagation()
      handler?.(e)
    },
    [handler],
  )
}

// convertExpirationDate converts expiration dates for demos
export const convertExpirationDate = (expirationDate: string) => {
  if (expirationDate === '') {
    return ''
  }
  //  expiration date comes in this format -> 2025-06-16 07:00:00
  const parsedDate = parse(expirationDate, 'yyyy-MM-dd HH:mm:ss', new Date())
  return format(parsedDate, 'yyyy-MM-dd')
}
